import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/user/auth.service';
import { map, take } from 'rxjs/operators';
import { LoggerService } from '../services/common/logger.service';
import { isPlatformBrowser } from '@angular/common';

export const authGuard: CanActivateFn = (route, state) => {
  const platformId = inject(PLATFORM_ID);

  // Skip guard execution during SSR
  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  const authService = inject(AuthService);
  const router = inject(Router);
  const logger = inject(LoggerService);

  return authService.currentUser$.pipe(
    take(1), // Take the first value emitted
    map(user => {
      if (user) {
        return true; // User is logged in, allow access
      } else {
        // User is not logged in, redirect to home (or login page)
        logger.info('AuthGuard: User not logged in, redirecting to /');
        router.navigate(['/']);
        return false; // Prevent access
      }
    }),
  );
};
